import { fetchQuery, graphql } from "relay-runtime"
import {
  deQuestionnaireSummarizerQuery as deQuestionnaireSummarizerQueryType,
  SummarizeQuestionnaireInput,
} from "@/modules/chats/services/ai/de/__generated__/deQuestionnaireSummarizerQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query deQuestionnaireSummarizerQuery($input: SummarizeQuestionnaireInput!) {
    summarizeQuestionnaire: de_summarizeQuestionnaire(input: $input) {
      text
      result
      fileHash
      aiRequestDurationMs
      aiAnonymizationRequestDurationMs
    }
  }
`

export const deQuestionnaireSummarizerQuery = (input: SummarizeQuestionnaireInput) => {
  return fetchQuery<deQuestionnaireSummarizerQueryType>(RelayEnvironment, query, { input }).toPromise()
}
